import React, { useEffect } from 'react';
import Home from '../components/Home';
import { trackPageView } from '../utils/analytics';
// ...existing code...

const HomePage = () => {
    useEffect(() => {
        trackPageView('/');
    }, []);

    return (
        <div>
            <Home />
           
        </div>
    );
};

export default HomePage;